import { writable } from 'svelte/store'

type ExitModal = {
	open: boolean
}

export default writable<ExitModal>({
	open: false
})
